import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';

import { showToast } from '@app/providers/ToastProvider';

import configRequest from '../configRequest';

export type DownloadPdfType = 'application' | 'tax-form';

export interface AMODownloadApplicationData {
	application_id: number;
	type: DownloadPdfType;
}

export type AMODownloadApplicationResponse = {
	status: boolean;
	pdf: { blob: string };
};

const downloadApplication = configRequest<AMODownloadApplicationResponse, AMODownloadApplicationData>({
	requestPrefix: 'amo/applications/downloadApplication',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.DOWNLOAD_APPLICATION(),
		method: HTTP_METHODS_ENUM.POST,
		data,
	}),
	onSuccess: input => {
		showToast.success(
			input?.type === 'tax-form'
				? 'Tax Form has been downloaded successfully'
				: 'Application has been downloaded successfully',
		);
	},
});

export const downloadApplicationValidation = configRequest<AMODownloadApplicationResponse, AMODownloadApplicationData>({
	requestPrefix: 'amo/applications/downloadApplicationValidation',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.DOWNLOAD_APPLICATION(),
		method: HTTP_METHODS_ENUM.POST,
		data: {
			...data,
			only_validate: true,
		},
	}),
});

export const downloadTaxFormValidation = configRequest<AMODownloadApplicationResponse, AMODownloadApplicationData>({
	requestPrefix: 'amo/applications/downloadTaxFormValidation',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.DOWNLOAD_APPLICATION(),
		method: HTTP_METHODS_ENUM.POST,
		data: {
			...data,
			only_validate: true,
		},
	}),
});

export default downloadApplication;
